import React from 'react'
import { Outlet } from 'react-router-dom'

const Web3BilleteraComponent = () => {
  return (
    <div>
        <Outlet/>
    </div>
  )
}

export default Web3BilleteraComponent